import { render, staticRenderFns } from "./Overdrafts.vue?vue&type=template&id=e2fbedd0&"
import script from "./Overdrafts.vue?vue&type=script&lang=ts&"
export * from "./Overdrafts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports